export enum CancellationReasonsAcions {
    SET_SELECTED_REASON = "setSelectedReason",
    TOGGLE_REASONS_PANEL = "toggleReasonsPanel",
    SET_ACTIVE_REASON_TYPE = "setActiveReasonType"
}